import { useTranslation } from 'react-i18next';
import { KizenTypography } from 'app/typography';
import ColorLabel from 'components/Fields/ColorLabel';
import { getAutomationStatusDisplayData } from './getAutomationStatusDisplayData';

const StatusWidget = ({ automation }) => {
  const { t } = useTranslation();
  const {
    status,
    automationActive,
    automationDeleted,
    warning,
    inQueue,
    debugMode,
  } = automation;

  const isDebugActive = status === 'active' && debugMode === 'active';

  const chosenDisplayData = getAutomationStatusDisplayData(
    status,
    automationActive,
    automationDeleted,
    warning,
    isDebugActive,
    inQueue
  );

  return (
    <KizenTypography>
      <ColorLabel color={chosenDisplayData.statusColor}>
        {chosenDisplayData.label(t)}
      </ColorLabel>
    </KizenTypography>
  );
};

export default StatusWidget;
